var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11C10.6569 11 12 9.65685 12 8C12 6.34315 10.6569 5 9 5C7.60212 5 6.42755 5.95608 6.09451 7.25H3C2.58579 7.25 2.25 7.58579 2.25 8C2.25 8.41421 2.58579 8.75 3 8.75H6.09451C6.42755 10.0439 7.60212 11 9 11ZM3 15.25C2.58579 15.25 2.25 15.5858 2.25 16C2.25 16.4142 2.58579 16.75 3 16.75H10C10.4142 16.75 10.75 16.4142 10.75 16C10.75 15.5858 10.4142 15.25 10 15.25H3ZM15 19C16.3979 19 17.5725 18.0439 17.9055 16.75H21C21.4142 16.75 21.75 16.4142 21.75 16C21.75 15.5858 21.4142 15.25 21 15.25H17.9055C17.5725 13.9561 16.3979 13 15 13C13.3431 13 12 14.3431 12 16C12 17.6569 13.3431 19 15 19ZM14 7.25C13.5858 7.25 13.25 7.58579 13.25 8C13.25 8.41421 13.5858 8.75 14 8.75H21C21.4142 8.75 21.75 8.41421 21.75 8C21.75 7.58579 21.4142 7.25 21 7.25H14Z",
    fill: "#28303F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.13b2faca926ccc5397c0cf3535078aff.svg";
export { ForwardRef as ReactComponent };